export const globalStyleConstants = {
  headerAndBottomBarHeight: 48,
};
